import { render, staticRenderFns } from "./Notifications_edit.vue?vue&type=template&id=09826420"
import script from "./Notifications_edit.vue?vue&type=script&lang=js"
export * from "./Notifications_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports